<template>
    <v-layout
        row
        wrap
        v-if="photoList && photoList.length > 0"
        class="photo-review">
        <v-flex xs3
                v-for="(img, index) in photoList"
                :key="index"
                class="photo-review__item"
                pa-2>
            <v-img v-if="isImageType(img.type ? img.type : img.mediaType)"
                   class="photo-review__item-img"
                   ref="editImage"
                   cover
                   height="100"
                   :src="img.url">
                <v-icon @click.prevent="removePhotoHandler(index)"
                        :data-qe-id="`remove_photo_button_${index}`"
                        size="40"
                        color="black"
                        class="photo-review__remove-btn">close</v-icon>
            </v-img>
            <div v-if="isVideoType(img.type ? img.type : img.mediaType)" class="outer-box">
                <video height="100">
                    <source :src="img.url" type="video/mp4">
                </video>
                <div class="inner-box">
                    <v-icon @click.prevent="removePhotoHandler(index)"
                            :data-qe-id="`remove_photo_button_${index}`"
                            size="40"
                            color="black"
                            class="inner-box__remove-btn">close</v-icon>
                </div>
            </div>
        </v-flex>
        <v-flex
            xs3
            v-if="canAddMore"
            pa-2
            class="photo-review__add">
            <photo-uploader
                :multiple="true"
                uploader-id="photo_review_add_more_button"
                :is-type-add-more="true"
                :maximum-files="numberOfFilesAllowed"
                :upload-callback="addMorePhotosHandler"
                :fileSizeFromOtherSources="$attrs.fileSizeFromOtherSources"
                :alreadyAddedImages="photoList"
                :maxFileSizeLimit="$attrs.maxFileSizeLimit">
            </photo-uploader>
        </v-flex>
    </v-layout>
</template>

<script>
  import PhotoUploader from "./PhotoUploader";
  import { appCommonConstants } from "../appCommon.constants";

  export default {
    name: "PhotoReview",
    components: {
      PhotoUploader,
    },
    inheritAttrs: false,
    props: {
      photoList: {
        type: Array,
        required: true,
      },
      removePhotoHandler: {
        type: Function,
        required: true,
      },
      addMorePhotosHandler: {
        type: Function,
      },
      canAddMore: {
        type: Boolean,
        default: false,
      },
      numberOfFilesAllowed: {
        type: Number,
      },
    },
    data: () => {
        return {
            appCommonConstants,
        };
    },
    methods: {
        isImageType(type) {
            return new RegExp(`${this.appCommonConstants.IMAGE_FILE_TYPES_ACCEPTED}`.replace(/,/g, '|')).test(type);
        },
        isVideoType(type) {
            return new RegExp(`${this.appCommonConstants.VIDEO_FILE_TYPES_ACCEPTED}`.replace(/,/g, '|')).test(type);
        },
    },
  };
</script>

<style lang="scss">
  @import "../../common/styles/_colors.scss";

  .photo-review {
    position: relative;
    background-color: $ypo-light-gray;

    &__item {
      position: relative;

      &-img {
        border: 1px solid $ypo-medium-gray;
        background: $ypo-medium-gray;
        border-radius: 4px;
        transition: 0.3s all ease;

        .v-responsive__content {
          &:hover {
            background-color: rgba($black, 0.6);

            .photo-review__remove-btn {
              opacity: 1;
              visibility: visible;
            }
          }
        }
      }
    }

    &__remove-btn {
      font-size: 24px !important;
      right: 0;
      position: absolute;
      font-weight: 600;
      color: $white !important;
      left: 0;
      top: 0;
      bottom: 0;
      opacity: 0;
      visibility: hidden;
    }

    &__add {
      .photo-uploader {
        height: 100px;

        .photo-uploader__btn {
          min-height: inherit;
          background: rgba($ypo-dark-gray, 0.1);
          border: 1px dashed rgba($ypo-dark-gray, 0.2);
          padding: 0;
          top: 0;
          border-radius: 4px;
          margin-top: 0px;

          i {
            font-size: 30px !important;
            line-height: 90px;
            margin-top: 0;
            font-weight: 600;
          }
        }
      }
      
    }
  }
    .outer-box {
        position: relative;
        height: 100px;
        overflow: hidden;
        border-radius: 4px;
        video {
            display: block;
            border-radius: 4px;
        }
        .inner-box {
          
                position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    line-height: 100px;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s all ease;
    cursor: pointer;
    border-radius: 4px;
    i {
        color: $white !important;
            font-size: 24px !important;
    font-weight: 600;
    }
        }
        &:hover {
           .inner-box {
               opacity: 1;
               visibility: visible;
           } 
        }
    }
    @media (max-width: 767px) {
        .photo-review {
         &__item-img{
              height: 50px !important;
          }
         &__add .photo-uploader {
             height: 50px !important;
             .v-icon {
                display: block !important;
                line-height: 50px !important;
             }
         }
      }
      }
</style>
